import { useQuery } from 'hooks/useCustomQuery';
import { axios } from '@/services/axios';
import { useDispatch } from 'react-redux';

const useGetCompanyDefinedAttributes = (currentCompanyData) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['companyDefinedAttributes', currentCompanyData.id],
        queryFn: async () => {
            if (!currentCompanyData.id) return null;
            const res = await axios
                .get(`company/${currentCompanyData.id}/definedattributes`)
                .then((response) => {
                    dispatch({
                        type: 'CHANGE_CURRENT_COMPANY_DATA',
                        payload: {
                            ...currentCompanyData,
                            definedAttributes: response.data,
                        },
                    });
                    return response;
                });
            return res.data;
        },
        enabled: Boolean(currentCompanyData.id),
        staleTime: 0,
    });
};

export default useGetCompanyDefinedAttributes;
